import { defineElement } from '@webtides/element-js';

import BaseSpecListFilter from '@zeg/base-light-module/frontend/components/structures/_category-page/spec-list-filter/spec-list-filter.class';

import style from './spec-list-filter.css';

class SpecListFilter extends BaseSpecListFilter {
    styles() {
        return [style];
    }
}

defineElement('spec-list-filter', SpecListFilter);
